import { useMemo } from 'react';
import useCrmObjectName from 'marketing-platform-lib/hooks/useCrmObjectName';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import useSkipCrm from 'framework-listing-lib/internal/hooks/useSkipCrm';
import { useCurrentTypeDefinition, useTypeDefinitions } from 'framework-listing-lib/internal/hooks/useObjectTypeDefinitions';
export default function useCrmObjectTypeName({
  objectTypeIdArg,
  textTransform = 'lowercase'
} = {}) {
  const currentObjectTypeId = useObjectTypeId();
  const objectTypeId = useMemo(() => objectTypeIdArg || currentObjectTypeId, [currentObjectTypeId, objectTypeIdArg]);
  const skipCrm = useSkipCrm();
  const typeDefinition = useCurrentTypeDefinition();
  const typeDefinitions = useTypeDefinitions();
  const resolvedTypeDefinition = useMemo(() => {
    if (objectTypeIdArg !== currentObjectTypeId) {
      return typeDefinitions.find(def => def.objectTypeId === objectTypeIdArg);
    }
    return typeDefinition;
  }, [currentObjectTypeId, objectTypeIdArg, typeDefinition, typeDefinitions]);
  return useCrmObjectName(objectTypeId, {
    skip: skipCrm,
    textTransform,
    typeDefinition: resolvedTypeDefinition !== null && resolvedTypeDefinition !== void 0 && resolvedTypeDefinition.singularForm && resolvedTypeDefinition.pluralForm ? resolvedTypeDefinition : undefined
  });
}